import create from "zustand";

interface ServerUrl {
  url: string;
}

export const useServerUrl = create<ServerUrl>(() => ({
  url: "https://apiarmaduradodragao.checkoute2e.com",
  // url: "http://localhost:4000",
}));
